module.exports = __webpack_public_path__ + "si.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/si.svg
// module id = 1057
// module chunks = 0